import React, {useState, useEffect} from "react"
import {Select} from "@irati/ui/src/FormItem"
import teamService from "@irati/identity/services/teams"
import authentication from "@irati/auth"
import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

interface Options {
  value: string
  label: string
}

export type CBTeamSelectOnChange = (values: string[]) => any

interface Props extends InjectIntl {
  value: string[]
  onChange: CBTeamSelectOnChange
}

const CBTeamSelect: React.FC<Props> = (props) => {
  const [isLoading, setIsloading] = useState(true)
  const [options, setOptions] = useState<Options[]>([])

  useEffect(() => {
    teamService.list(authentication.userTenant().uuid).then((teams) => {
      setOptions(teams.map(({uuid, public_name}) => ({value: uuid, label: public_name})))
      setIsloading(false)
    })
  }, [])

  return (
    <Select
      isMulti
      isCreatable
      isLoading={isLoading}
      options={options}
      value={props.value}
      onChange={props.onChange}
      label={props.formatMessage({id: "admin.companyBenefits.teams.label"})}
      validation={Validation.string(props.formatMessage({id: "admin.companyBenefits.teams.error"}))}
    />
  )
}

export default injectIntl(CBTeamSelect)
